"use strict";

exports.__esModule = true;
exports.DrmRuleHelper = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.object.entries.js");

require("core-js/modules/es.object.assign.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.array.find.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.join.js");

var _sdkAjax = require("../util/sdk-ajax");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var DrmRuleHelper = /*#__PURE__*/function () {
  function DrmRuleHelper(_ref) {
    var query_drm_limit_params = _ref.query_drm_limit_params,
        user_info = _ref.user_info,
        limit_type = _ref.limit_type;
    this.query_drm_limit_params = void 0;
    this.user_info = void 0;
    this.limit_type = void 0;
    this.mapRuleNameToHandler = this.mapRuleNameToHandler.bind(this);
    this.query_drm_limit_params = query_drm_limit_params;
    this.user_info = user_info;
    this.limit_type = limit_type || 'double';
  }
  /**
   * 将 mpInfo 的 drm 规则合并到 product 信息里面
   */


  var _proto = DrmRuleHelper.prototype;

  _proto.mapDrmRules =
  /*#__PURE__*/
  function () {
    var _mapDrmRules = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(param) {
      var mpInfo, productList, promiseArray;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              mpInfo = param.mpInfo, productList = param.productList;
              promiseArray = Object.entries(mpInfo).map(this.mapRuleNameToHandler).map(function (_ref2) {
                var ruleName = _ref2.ruleName,
                    handler = _ref2.handler;
                var handlerParam = Object.assign({}, param, {
                  productList: productList,
                  ruleName: ruleName,
                  rule: mpInfo[ruleName]
                });
                return handler(handlerParam);
              });

              if (promiseArray.length) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", productList);

            case 4:
              return _context.abrupt("return", Promise.all(promiseArray).then(function (productListResultArray) {
                // 对所有计算完规则的物品列表进行合并，这里会有后到的活动覆盖先到的活动的问题
                var mergedProductList = productListResultArray.reduce(function (pre, cur) {
                  return cur.map(function (ele, index) {
                    return Object.assign(pre[index] || {}, ele);
                  });
                }, []);
                return mergedProductList;
              }).catch(function (error) {
                console.log(error);
                return param.productList;
              }));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mapDrmRules(_x) {
      return _mapDrmRules.apply(this, arguments);
    }

    return mapDrmRules;
  }()
  /**
   * 将道具折扣信息合并到物品信息中
   */
  ;

  _proto.mapBuyGoodsRule = function mapBuyGoodsRule(param) {
    var _this = this;

    var productList = param.productList,
        rule = param.rule,
        ignoreAllowChannel = param.ignoreAllowChannel,
        ruleName = param.ruleName; // 读不到规则的时候直接返回旧数据

    if (!rule) return Promise.resolve(productList);
    var newProductList = productList.map(function (productItem) {
      /**
       * 已经匹配过的元素不再进行处理，避免二次打折的情况
       */
      if (productItem.matchedRule) {
        return productItem;
      }

      var matchedRule;
      /**
       * 遍历 rule.goods.rule_item 匹配规则
       * rule 的数据格式可以参考：https://git.code.oa.com/boss_mp/drm_svr/wikis/V3%E6%9F%A5%E8%AF%A2%E5%8D%8F%E8%AE%AE
       * 1. 检测 product_id 字符串是否包含物品的 productid
       * 2. 检测 allow_channel 是否等于物品对应的 channel，需要关注 allow_channel = * 的情况，允许所有渠道
       */

      rule.goods.rule_item.forEach(function (ruleItem) {
        var isProductIdInclude = ruleItem.product_id.split(',').find(function (ele) {
          return ele === productItem.productid;
        });
        var targetChannel = productItem.targetChannel;
        var isChannelMatch = ignoreAllowChannel || ruleItem.allow_channel.indexOf(targetChannel) > -1 || ruleItem.allow_channel === '*';

        if (_this.isRuleItemTakeEffect(ruleItem) && isChannelMatch && isProductIdInclude) {
          matchedRule = ruleItem;
        }
      });

      if (matchedRule) {
        // 计算折后价格，代入到 price 和 show_price 字段，与模板对应
        var isFixedDiscount = /FIXED:(\d+)/.exec(matchedRule.discount);
        var isPercentDiscount = Number(matchedRule.discount);
        var discountPrice = productItem.price;

        if (isFixedDiscount) {
          discountPrice = "" + parseInt(isFixedDiscount[0].replace('FIXED:', ''), 10);
        } else if (typeof isPercentDiscount === 'number') {
          discountPrice = "" + Math.floor(parseInt(productItem.price, 10) * isPercentDiscount / 100);
        }

        return Object.assign(productItem, {
          matchedRule: matchedRule,
          show_price: productItem.noShowPrice ? undefined : productItem.price,
          original_price: productItem.price,
          price: discountPrice
        });
      }

      return productItem;
    });
    return this.requestDrmLimit(Object.assign({}, param, {
      productList: newProductList,
      buyType: ruleName
    })).catch(function (error) {
      console.error(error);
      return newProductList;
    });
  }
  /**
   * 将游戏币活动信息合并到物品信息中
   */
  ;

  _proto.mapBuyCurrencyRule = function mapBuyCurrencyRule(param) {
    var _this2 = this;

    var productList = param.productList,
        rule = param.rule; // 读不到规则的时候直接返回旧数据

    if (!rule) return Promise.resolve(productList);
    var newProductList = productList.map(function (productItem) {
      var _productItem$uptopres;

      /**
       * 已经匹配过的元素不再进行处理，避免二次打折的情况
       */
      if ((_productItem$uptopres = productItem.uptopresentRule) != null && _productItem$uptopres.length) {
        return productItem;
      }
      /**
       * 遍历 rule.goods.rule_item 匹配规则
       * 1. 检测 allow_channel 是否等于物品对应的 channel，需要关注 allow_channel = * 的情况，允许所有渠道
       * 2. 检测 currency_type 是否匹配
       * 3. 检测 currency_zone 是否匹配
       */


      Object.keys(rule).filter(function (ruleKey) {
        return ruleKey.indexOf('uptopresent') > -1;
      }).forEach(function (uptopresentKey) {
        var matchedRule;
        var uptopresentRule = Object.assign({}, rule[uptopresentKey]);
        var matchedRuleItemArray = [];
        uptopresentRule.rule_item.forEach(function (ruleItem, index) {
          var targetChannel = productItem.targetChannel;
          var isChannelMatch = ruleItem.allow_channel === '*' || ruleItem.allow_channel.indexOf(targetChannel) > -1;
          var isCurrencyTypeMatch = ruleItem.currency_type === '*' || ruleItem.currency_type.indexOf(productItem.currency_type) > -1;

          if (_this2.isRuleItemTakeEffect(ruleItem) && isChannelMatch && isCurrencyTypeMatch) {
            matchedRule = ruleItem;
            matchedRuleItemArray.push(ruleItem);
          }

          if (matchedRule) {
            /** 计算赠送的游戏币加到物品中 */
            var originalNum = productItem.originalNum || productItem.num;

            var send_num = _this2.getSendNumByRuleAndProductNum(matchedRule, Number(originalNum) || 0);

            uptopresentRule.rule_item[index].send_num = send_num;
            /** 直接用匹配到的档位覆盖活动信息，便于后续逻辑处理 */

            Object.assign(productItem, {
              originalNum: originalNum,
              num: "" + (Number(productItem.num) + Number(send_num))
            });
          }
        });

        if (matchedRule) {
          uptopresentRule.rule_item = matchedRuleItemArray;
          var newUptopresentRule = productItem.uptopresentRule || [];
          newUptopresentRule.push(uptopresentRule);
          Object.assign(productItem, {
            /** 将满赠活动的 rule_id 等信息透传出去 */
            uptopresentRule: newUptopresentRule
          });
        }
      });
      return productItem;
    });
    return newProductList;
  }
  /**
   * 根据满赠规则和物品信息计算赠送游戏币数量
   * @param rule 满赠规则
   * @param productItem 物品信息
   */
  ;

  _proto.getSendNumByRuleAndProductNum = function getSendNumByRuleAndProductNum(rule, product_num) {
    var _rule$present_item, _rule$present_item$;

    var send_type = (_rule$present_item = rule.present_item) == null ? void 0 : (_rule$present_item$ = _rule$present_item[0]) == null ? void 0 : _rule$present_item$.send_type;
    if (!send_type) return 0;

    switch (send_type) {
      /** 按比例赠送，需要读取 send_rate * product_item.num */
      case '1':
        {
          /** 最终赠送的比例，以最后一个物品数量大于 num 值的 send_rate 为准，初始值为 0 */
          var send_rate = rule.present_item.reduce(function (pre, cur) {
            if (+cur.num < product_num) {
              return +cur.send_rate;
            }

            return pre;
          }, 0);
          console.log("send_rate:" + send_rate + ".product_item.num:" + product_num);
          return Math.ceil(product_num * send_rate / 100);
        }

      /** 直接赠送，需要读取 send_num */

      case '2':
        /** 寻找 num 与物品数量一致的规则读取其 send_num */
        return rule.present_item.reduce(function (pre, cur) {
          if (+cur.num === product_num) {
            return +cur.send_num;
          }

          return pre;
        }, 0);

      default:
        return 0;
    }
  }
  /**
   * 空白默认的处理函数
   */
  ;

  _proto.emptyRuleHandler = function emptyRuleHandler(_ref3) {
    var productList = _ref3.productList;
    return Promise.resolve(productList);
  }
  /**
   * 根据规则名称返回处理函数
   * @param {String}} ruleName 规则名称
   */
  ;

  _proto.mapRuleNameToHandler = function mapRuleNameToHandler(_ref4) {
    var ruleName = _ref4[0],
        ruleValue = _ref4[1];

    if (ruleValue.goods) {
      return {
        ruleName: ruleName,
        handler: this.mapBuyGoodsRule.bind(this)
      };
    }

    if (ruleValue.uptopresent) {
      return {
        ruleName: ruleName,
        handler: this.mapBuyCurrencyRule.bind(this)
      };
    }

    return {
      ruleName: ruleName,
      handler: this.emptyRuleHandler.bind(this)
    };
  }
  /**
   * 实现查询活动资格的功能
   */
  ;

  _proto.requestDrmLimit = function requestDrmLimit(_ref5) {
    var _this$user_info;

    var productList = _ref5.productList,
        buyType = _ref5.buyType;

    /** 没有命中任何活动物品时，不发送资格查询请求 */
    var hasMatchedRuleProductList = productList.length ? productList.filter(function (ele) {
      return !!ele.matchedRule;
    }) : [];

    if (!hasMatchedRuleProductList.length) {
      return Promise.resolve(productList);
    }

    var queryParams = Object.assign({}, this.query_drm_limit_params, {
      openid: this.query_drm_limit_params.openid + "_receive",
      buy_type: buyType,
      product_list: hasMatchedRuleProductList.reduce(function (pre, cur) {
        if (pre.indexOf(cur.productid) < 0) {
          pre.push(cur.productid);
        }

        return pre;
      }, []).join(',')
    });

    if (this.limit_type === 'single') {
      return this.requestLimit({
        queryParams: Object.assign({}, queryParams, {
          openid: this.query_drm_limit_params.openid
        }),
        productList: productList
      });
    }

    return Promise.all([this.requestLimit({
      queryParams: Object.assign({}, queryParams, {
        openid: this.query_drm_limit_params.openid + "_receive"
      }),
      productList: productList
    }), (_this$user_info = this.user_info) != null && _this$user_info.uid ? this.requestLimit({
      queryParams: Object.assign({}, queryParams, {
        openid: this.user_info.uid + "_present"
      }),
      productList: productList
    }) : Promise.resolve(productList)]).then(function (_ref6) {
      var productList = _ref6[0];
      return productList;
    });
  };

  _proto.requestLimit = function requestLimit(_ref7) {
    var _this3 = this;

    var queryParams = _ref7.queryParams,
        productList = _ref7.productList;
    var drm_info = queryParams.use_json ? Object.assign({}, queryParams.drm_info, {
      limit_query: 'all'
    }) : queryParams.drm_info + "&limit_query=all";
    return (0, _sdkAjax.ajax)({
      method: 'POST',
      url: '/h5/overseah5/query_drm_limit',
      param: Object.assign(queryParams, {
        drm_info: drm_info
      })
    }).then(function (response) {
      if (response.ret !== 0) {
        return productList;
      } // 遍历资格消耗情况，如果资格已经消耗完毕，则用 show_price 覆盖 price 字段，并且将 show_price 置空，即设为原价


      try {
        var detail = response.info.limit_info.resop_mpinfo.detail;
        detail.forEach(function (detailItem) {
          // if (detailItem.product_id === 'testUniresProduct') {
          //     detailItem.used_quota = 1000;
          // }
          for (var i = 0; i < productList.length; i += 1) {
            var _productList$i$quotaI, _productList$i$quotaI2;

            var isSameProduct = productList[i].productid === detailItem.product_id;

            var quotaInfo = _this3.getQuotaInfo(detailItem); // let drmActivityQuotaLeft = 0;
            // if (quotaResult.total_quota > 0) {
            //     drmActivityQuotaLeft = quotaResult.total_quota - quotaResult.used_quota;
            // }
            // /** 这里避免接口异常情况下减出来为负数的情况，异常时统一为 0 */
            // if (drmActivityQuotaLeft < 1) {
            //     drmActivityQuotaLeft = 0;
            // }


            if (isSameProduct && !((_productList$i$quotaI = productList[i].quotaInfo) != null && (_productList$i$quotaI2 = _productList$i$quotaI.runOutInfo) != null && _productList$i$quotaI2.isRunOut)) {
              var _quotaInfo$runOutInfo;

              productList[i].quotaInfo = quotaInfo; // productList[i].uin_quota = quotaResult.total_quota;
              // productList[i].used_quota = quotaResult.used_quota;
              // productList[i].drmActivityQuotaLeft = drmActivityQuotaLeft;

              if ((_quotaInfo$runOutInfo = quotaInfo.runOutInfo) != null && _quotaInfo$runOutInfo.isRunOut && productList[i].original_price) {
                productList[i].price = productList[i].original_price;
                productList[i].show_price = undefined;
              }
            }
          }
        });
        return productList;
      } catch (error) {
        // 无论任何报错，直接将原物品数组返回
        console.log(error);
        return productList;
      }
    }).catch(function () {
      return productList;
    }); // 请求失败时，直接将原物品数组返回
  };

  _proto.isRuleItemTakeEffect = function isRuleItemTakeEffect(ruleItem) {
    var ruleBeginTime = ruleItem.begin_time.replace(/-/g, '/');
    var ruleEndTime = ruleItem.end_time.replace(/-/g, '/');
    /** 在 iOS 设备 / IE 浏览器下面不支持 YYYY-MM-DD HH:hh:ss 格式的字符串转日期，需要将 - 改为 / */

    var beginTime = new Date(ruleBeginTime).getTime() || 0;
    var endTime = new Date(ruleEndTime).getTime() || 0;
    return Date.now() > beginTime && Date.now() < endTime;
  }
  /**
   * 判断一个物品的活动额度是否已经用完
   * 判断逻辑可以参考: https://iwiki.oa.tencent.com/pages/viewpage.action?pageId=260246866
   * @param quotaItem drm 返回的额度信息
   */
  ;

  _proto.getQuotaInfo = function getQuotaInfo(quotaItem) {
    var res = {
      totalQuotaInfo: undefined,
      uinQuotaInfo: undefined,
      runOutInfo: undefined
    };
    var isTotalRunOut = {
      runOutLimitType: 'total',
      isRunOut: quotaItem.total_quota > -1 && quotaItem.total_used_quota >= quotaItem.total_quota,
      used_quota: quotaItem.total_used_quota,
      total_quota: quotaItem.total_quota
    };
    var isTotalMonthRunOut = {
      runOutLimitType: 'total',
      runOutCycleType: 'month',
      isRunOut: quotaItem.month_total_quota > -1 && quotaItem.month_total_used_quota >= quotaItem.month_total_quota,
      used_quota: quotaItem.month_total_used_quota,
      total_quota: quotaItem.month_total_quota
    };
    var isTotalWeekRunOut = {
      runOutLimitType: 'total',
      runOutCycleType: 'week',
      isRunOut: quotaItem.week_total_quota > -1 && quotaItem.week_total_used_quota >= quotaItem.week_total_quota,
      used_quota: quotaItem.week_total_used_quota,
      total_quota: quotaItem.week_total_quota
    };
    var isTotalDayRunOut = {
      runOutLimitType: 'total',
      runOutCycleType: 'day',
      isRunOut: quotaItem.day_total_quota > -1 && quotaItem.day_total_used_quota >= quotaItem.day_total_quota,
      used_quota: quotaItem.day_total_used_quota,
      total_quota: quotaItem.day_total_quota
    };
    var isUinRunOut = {
      runOutLimitType: 'uin',
      isRunOut: quotaItem.uin_quota > -1 && quotaItem.used_quota >= quotaItem.uin_quota,
      used_quota: quotaItem.used_quota,
      total_quota: quotaItem.uin_quota
    };
    var isUinMonthRunOut = {
      runOutLimitType: 'uin',
      runOutCycleType: 'month',
      isRunOut: quotaItem.month_uin_quota > -1 && quotaItem.month_used_quota >= quotaItem.month_uin_quota,
      used_quota: quotaItem.month_used_quota,
      total_quota: quotaItem.month_uin_quota
    };
    var isUinWeekRunOut = {
      runOutLimitType: 'uin',
      runOutCycleType: 'week',
      isRunOut: quotaItem.week_uin_quota > -1 && quotaItem.week_uin_used_quota >= quotaItem.week_uin_quota,
      used_quota: quotaItem.week_uin_used_quota,
      total_quota: quotaItem.week_uin_quota
    };
    var isUinDayRunOut = {
      runOutLimitType: 'uin',
      runOutCycleType: 'day',
      isRunOut: quotaItem.day_uin_quota > -1 && quotaItem.day_uin_used_quota >= quotaItem.day_uin_quota,
      used_quota: quotaItem.day_uin_used_quota,
      total_quota: quotaItem.day_uin_quota
    };
    /** 判断顺序 */

    var judgeArray = [isTotalRunOut, isUinRunOut, isTotalMonthRunOut, isTotalWeekRunOut, isTotalDayRunOut, isUinDayRunOut, isUinWeekRunOut, isUinMonthRunOut];

    for (var i = 0; i < judgeArray.length; i += 1) {
      if (judgeArray[i].isRunOut === true) {
        res.runOutInfo = judgeArray[i];
        break;
      }
    }
    /** 共享额度的展示顺序 */


    var judgeTotalQuotaArray = [isTotalRunOut, isTotalMonthRunOut, isTotalWeekRunOut, isTotalDayRunOut].filter(function (ele) {
      return ele.total_quota > -1;
    });

    for (var _i = 0; _i < judgeTotalQuotaArray.length; _i += 1) {
      if (judgeTotalQuotaArray[_i].isRunOut === false) {
        res.totalQuotaInfo = judgeTotalQuotaArray[_i];
        break;
      }
    }

    if (!res.totalQuotaInfo) {
      res.totalQuotaInfo = judgeTotalQuotaArray[0];
    }
    /** 个人额度的展示顺序 */


    var judgeUinQuotaArray = [isUinDayRunOut, isUinWeekRunOut, isUinMonthRunOut, isUinRunOut].filter(function (ele) {
      return ele.total_quota > -1;
    });

    for (var _i2 = 0; _i2 < judgeUinQuotaArray.length; _i2 += 1) {
      if (judgeUinQuotaArray[_i2].isRunOut === false) {
        res.uinQuotaInfo = judgeUinQuotaArray[_i2];
        break;
      }
    }

    if (!res.uinQuotaInfo) {
      res.uinQuotaInfo = judgeUinQuotaArray[0];
    }

    return res;
  };

  return DrmRuleHelper;
}();

exports.DrmRuleHelper = DrmRuleHelper;